import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_PARTNER_GET_LISTING_STATS,
} from 'api/actionTypes';

export default async function getListingStats(
  { state, apiClient },
  { listingStatsId, listingManagementCompany, listingId, apartmentId, sinceDate, forceRefresh }
) {
  typeCheck('listingStatsId::NonEmptyString', listingStatsId);

  const partnerListingStatsRoute = ['partners', 'listingStats', listingStatsId];
  if (state.get(partnerListingStatsRoute) && !forceRefresh) {
    return state.get(partnerListingStatsRoute);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET_LISTING_STATS,
    queryId: listingStatsId,
    state: state,
    payload: {
      listingManagementCompany: listingManagementCompany,
      listingId: listingId,
      apartmentId: apartmentId,
      sinceDate: sinceDate,
    },
    onSuccess(partnerListingStats) {
      state.set(partnerListingStatsRoute, partnerListingStats);
    },
  });
}
